import * as React from 'react';
import queryString from 'query-string';
import { toTitleCase } from '@ally/aos-utils';
import { MboxTemplate, StyledMbox } from './StyledMbox';
export const LoginNotificationMBoxes = ({ rawQueryParams, isInPortal, }) => {
    const capitalizeSentence = (stringArray) => {
        return stringArray
            .map(element => {
            if (element.includes(' ')) {
                return element
                    .split(' ')
                    .map(el => toTitleCase(el))
                    .join(' ');
            }
            return toTitleCase(element);
        })
            .join(' / ');
    };
    const queryParamRegex = /(bank|invest|credit card|home loans|auto)/gi;
    const getMBoxContent = (queryParams) => {
        const matches = queryParams.match(queryParamRegex) || [''];
        return capitalizeSentence(matches);
    };
    // NOTE: queryString.parse(rawQueryParams) interpolates `%20` as whitespace | ' '
    const params = queryString.parse(rawQueryParams);
    const isLinkedFromBankInvestCC = params.linkRelationships
        ? queryParamRegex.test([...params.linkRelationships].join(''))
        : false;
    const mboxName = 'ally-login-notifications';
    const content = isLinkedFromBankInvestCC && params.linkRelationships
        ? {
            __html: `Log in with your <b>${getMBoxContent(params.linkRelationships)}</b> username to finish linking.`,
        }
        : { __html: '' };
    return (React.createElement(React.Fragment, null,
        !isInPortal && !isLinkedFromBankInvestCC && (React.createElement(StyledMbox, { name: mboxName })),
        isLinkedFromBankInvestCC && (React.createElement(MboxTemplate, { content: content, template: "icon-notification" }))));
};
//# sourceMappingURL=LoginNotificationMBoxes.js.map